import * as React from "react";
import { Table } from "soprasteria-ui-library";
import { IAdditionalAssignmentBaseArea } from "../../../models/IAdditionalAssignment";

interface IAdditionalAssignmentsTable {
    additionalAssignmentBaseAreas: IAdditionalAssignmentBaseArea[] | undefined;
}

export const AdditionalAssignmentsTable: React.FunctionComponent<IAdditionalAssignmentsTable> = ({ additionalAssignmentBaseAreas }) => {

    return (
        <section>
            {
                additionalAssignmentBaseAreas ?
                    <Table hoverableRows={additionalAssignmentBaseAreas.length > 0}>
                        <thead>
                            <tr>
                                <th>Mottagning</th>
                                <th>Basområdesnr</th>
                                <th>Basområdesnamn</th>
                                <th>Vårdbehovsområde</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                additionalAssignmentBaseAreas.length > 0 ?
                                    additionalAssignmentBaseAreas.map((additionalAssignmentBaseArea, key) => {
                                        return (
                                            <tr key={key} >
                                                <td>{additionalAssignmentBaseArea.careProvider.displayCareProviderName}</td>
                                                <td>{additionalAssignmentBaseArea.baseAreaCode}</td>
                                                <td>{additionalAssignmentBaseArea.baseAreaName}</td>
                                                <td>{additionalAssignmentBaseArea.careNeedArea}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr><td colSpan={4}>Inga basområden hittades</td></tr>
                            }
                        </tbody>
                    </Table>
                    : null
            }
        </section>
    )
}